export const countryCodes = ['au', 'nz'] as const;
export type CountryCode = (typeof countryCodes)[number];

export function isCountryCode(code: unknown): code is CountryCode {
    if (!code) {
        return false;
    }
    if (typeof code !== 'string') {
        return false;
    }
    return countryCodes.includes(code);
}
